import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class PurchaseOrderIdRequest {
    @ApiProperty()
    @IsNotEmpty()
    purchaseOrderId: number;
    @ApiProperty()
    reasonClosing?: string;
}